export const TEST_ID = 'newOperationButton';

export const LABEL = 'New Operation';

// Plus-icon SVG geometry — 14×14 viewBox, two 2px stroke lines meeting at center.
// Matches FAA drawer v2 prototype spec (drawer.jsx, Primary CTA section).
export const ICON_SIZE = 14;

export const PLUS_START = 2;

export const PLUS_MIDDLE = 7;

export const PLUS_END = 12;
